<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <!--Institucional -->
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4
                class="pull"
              >La diversidad y participación como base de una proyección institucional.</h4>
              <p
                class="pull"
              >A través de la realización de Jornadas Estratégicas a nivel de Departamentos, Escuelas y Facultades, las unidades académicas se proyectaron a los desafíos de la región, del país y del mundo desde una perspectiva disciplinar. De esta manera, se podrán visualizar las distintas iniciativas estratégicas propuestas categorizadas en ejes estratégicos institucionales.</p>
            </v-flex>
          </v-layout>

          <br />
          <v-flex md12 lg12 xs12 sm12>
            <v-carousel height="350px" :cycle="false" hide-delimiters class="carousel">
              <v-carousel-item v-for="(item,i) in carousel" :key="i" :src="item"></v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-flex>
      </v-flex>
      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile class="padding">
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="dialog = true"
                        target="_blank"
                      >Resultado Usach</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="padding">
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        v-if="this.$session.getAll().userType != 'Vicerrector'"
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(3)"
                        target="_blank"
                      >Desarrollo Estratégico</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
        <!-- <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="img3" class="image" @click="dialog = true" />
          </v-flex>
        </v-layout>-->
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile class="padding">
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="dialog = true"
                    target="_blank"
                  >Resultado Usach</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="padding">
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    v-if="this.$session.getAll().userType != 'Vicerrector'"
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(3)"
                    target="_blank"
                  >Desarrollo Estratégico</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>

    <!-- <v-layout>
      <v-dialog v-model="dialog" width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Asistencia DGE</span>
          </v-card-title>
          <div class="form-group">
            <label for="comment">Comenta tus inquietudes</label>
            <textarea class="form-control" rows="5" id="comment" v-model="visionPropuesta"></textarea>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>-->

    <v-dialog v-model="dialog" width="500px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>
          <span class="headline">Importante</span>
        </v-card-title>
        <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
          <v-layout row>
            <p
              style="text-align: justify;"
            >En estos momentos serás redirigido a una nueva plataforma donde podrás visualizar los resultados de las jornadas.</p>
          </v-layout>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#394049" flat="flat" @click="dialog = false">Cerrar</v-btn>
          <v-btn
            color="#ec6a12"
            flat="flat"
            href="https://plan-estrategico.netlify.com/"
            target="_blank"
          >Ir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import img1 from "../../assets/BANNER_2.png";
import img2 from "../../assets/intitu.png";
import img3 from "../../assets/nuevaasistencia.png";
import img4 from "../../assets/depto.png";
import img5 from "../../assets/entorno.png";

import img6 from "../../assets/carruDepto/1.jpg";
import img7 from "../../assets/carruDepto/2.jpg";
import img8 from "../../assets/carruDepto/3.jpg";
import img9 from "../../assets/carruDepto/4.jpg";
import img10 from "../../assets/carruDepto/5.jpg";
import img11 from "../../assets/carruDepto/6.jpg";
import img12 from "../../assets/carruDepto/7.jpg";
import img13 from "../../assets/carruDepto/8.jpg";
import img14 from "../../assets/carruDepto/9.jpg";
import img15 from "../../assets/carruDepto/10.jpg";
import img16 from "../../assets/carruDepto/11.jpg";
import img17 from "../../assets/carruDepto/12.jpg";
import img18 from "../../assets/carruDepto/13.jpg";
import img19 from "../../assets/carruDepto/14.jpg";
import img20 from "../../assets/carruDepto/15.jpg";
import img21 from "../../assets/carruDepto/16.jpg";
import img22 from "../../assets/carruDepto/17.jpg";
import img23 from "../../assets/carruDepto/18.jpg";

export default {
  data() {
    return {
      carousel: [
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img21,
        img22,
        img23
      ],
      img3: img3,
      dialog: false,
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      img2: img2,
      items: [
        { title: "° Informe PEI", icon: "question_answer", path: "1" },
        { title: "° Análisis de encuesta", icon: "question_answer", path: "2" },
        {
          title: "° Entrevista de Autoridades",
          icon: "question_answer",
          path: "3"
        },
        { title: "° Focus Group", icon: "question_answer", path: "4" }
      ],
      right: null
    };
  },
  created() {
    this.ccComplete = this.$session.getAll().ccData;
    this.getFiles(this.ccComplete.ccValor);
  },
  methods: {
    sendDge() {
      this.dialog = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    cargaArchivos() {
      //console.log("Cambiando de departamento " + this.menor.ccValor);

      this.getFiles(this.menor.ccValor);
    },

    getFiles(cc) {
      var cc = cc;
      axios
        .get(
          process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=" + cc,
          this.auth
        )
        .then(response => {
          this.filesDge = response.data;
          //console.log(this.filesDge);
          //console.log(this.filesDge["dge"][1]);
        })
        .catch(error => {
          console.error(error);
        });
    },

    redirect(index) {
      this.typeEstrategico = index;
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      if (pathFile != "") {
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/downloadFile?dir=" +
              pathFile,
            {
              responseType: "arraybuffer",
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            //console.log("archivo descargado ....");
            //console.log(response);
            this.forceFileDownload(response, nameFile);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        alert("Contenido no disponible");
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.list__tile__content {
  height: 100% !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}
.v-list-new {
  height: 100% !important;
  width: 100% !important;
}

.padding {
  padding-left: 0px !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/definicionEstrategica/IntroDefinicionEstrategica.vue